// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2JIAX","title":"AfterBackImages_title__LWO4-","images":"AfterBackImages_images__1Gehx"};